{
  "version": 1,
  "asset_id": "7c707587-58bc-48e5-a595-5d67b42a4e6d",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/7c707587-58bc-48e5-a595-5d67b42a4e6d/lap-band-diagram.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/7c707587-58bc-48e5-a595-5d67b42a4e6d/lap-band-diagram.webp",
  "original_filename": "lap-band-diagram.webp",
  "size": 87096,
  "content_type": "image/webp",
  "created_at": "2026-08-16T16:56:50Z"
}
